var now = +new Date();
var index = 0;

export default function uid() {
  return "rc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-upload/es/uid.js
// module id = 667
// module chunks = 0